import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import BASE_QUERY from '@/features/baseQuery';

export const supportApi = createApi({
	reducerPath: 'supportApi',
	tagTypes: ['SUPPORT_TICKET'],
	baseQuery: fetchBaseQuery(BASE_QUERY),
	endpoints: (builder) => ({
		createSupportTicket: builder.mutation({
			query: ({
				subject,
				category,
				areaImpacted,
				description,
				userAffected,
				attachments,
			}) => ({
				url: process.env.REACT_APP_CREATE_SUPPORT_TICKET,
				method: 'POST',
				body: {
					subject,
					category,
					areaImpacted,
					description,
					userAffected,
					attachments,
				},
			}),
			transformResponse: (response) => response,
			invalidatesTags: ['SUPPORT_TICKET'],
			transformErrorResponse: (response) => {
				console.error('Support ticket creation error:', response);
				return {
					status: response.status,
					message: response.data?.message || 'Failed to create support ticket',
				};
			},
		}),
	}),
});

export const { useCreateSupportTicketMutation } = supportApi;
